/* eslint-disable react/no-unsafe */
/* eslint-disable react/jsx-no-bind */
import PropertiesFilterByName from '@kognitiv/bf-library/dist/esm/PropertiesFilterByName';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import { getRegionalLocale } from '@kognitiv/bf-library';
import { inHotelProfilePage } from '../../shared/utils/UtilsHelper';
import DataFetchingDateRangeSelector from './DataFetchingDateRangeSelector/DataFetchingDateRangeSelector';
import DateRangeSelector from './DateRangeSelector';
import OccupancySelector from './OccupancySelector';
import SearchBarButton from './SearchBarButton';
import SearchBarItem from './SearchBarItem';
import SelectWithSearchContainer from './SelectWithSearch/containers';
import SpecialCodes from './SpecialCodes';
import UserPreferences from './UserPreferences';
import Wrapper from './Wrapper';
import { HotelsContext } from 'State/HotelsContext';
import { ECHO_WIDGET } from 'Constants/WidgetConfig';
import { searchBarShape, searchShape, settingsShape } from 'Constants/PropTypes';
import filterDataAndLabels from 'Constants/PropertiesFilters';
import COUPON_INTEGRATION from 'Constants/CouponIntegration';
import ErrorMessage from 'Components/ErrorMessage';

const moment = require('moment');

const getOccupancyForHotelsearch = (currentRoom, occupancy) => {
    const selectedRoomOcc = occupancy[currentRoom];
    console.assert(!!selectedRoomOcc,
        `Current room ${currentRoom} is not defined in occupancy ${JSON.stringify(occupancy)} `
        + `- ${JSON.stringify(selectedRoomOcc)}`);
    const childToken = selectedRoomOcc.children.map(child => child === -1 ? 0 : child).join(':');
    const hasChildrenInOccupancy = !!childToken;

    return hasChildrenInOccupancy
        ? `${selectedRoomOcc.adults}:${childToken}`
        : `${selectedRoomOcc.adults}`;
};

/**
 * Search Bar
 *
 * Implements the filters that allow the user to perform searches specifying the characteristics
 * of the room they want.
 * Each variable of the search is configured here. When the user makes a change the 'Update Results'
 * button is activated, and when the button is pressed the information here is sent to the server.
 */
class SearchBar extends PureComponent {
    constructor(props) {
        super(props);
        const { configuration, destinationsFilterEnabled } = props;
        const shouldRenderAutocomplete = configuration.autocompleteFilterEnabled
            && !configuration.isConnected && !destinationsFilterEnabled;
        this.state = { shouldRenderAutocomplete };
    }

    async componentDidMount() {
        const { loadClassifications } = this.context;
        const { channelId, search, isMultiProperty } = this.props;
        const { shouldRenderAutocomplete } = this.state;

        if (isMultiProperty && shouldRenderAutocomplete) {
            await loadClassifications(search.language, channelId);
        }
    }

    async componentDidUpdate(prevProps, prevState) {
        const { loadClassifications } = this.context;
        const { shouldRenderAutocomplete } = this.state;
        const { search, channelId } = this.props;
        const { shouldRenderAutocomplete: previousShouldRenderAutocomplete } = prevState;

        if (shouldRenderAutocomplete && shouldRenderAutocomplete !== previousShouldRenderAutocomplete) {
            await loadClassifications(search.language, channelId);
        }
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { configuration, destinationsFilterEnabled } = this.props;
        if ((nextProps.configuration.isConnected !== configuration.isConnected)
            || (nextProps.destinationsFilterEnabled !== destinationsFilterEnabled)
            || (nextProps.configuration.autocompleteFilterEnabled !== configuration.autocompleteFilterEnabled)) {
            const shouldRenderAutocomplete = nextProps.configuration.autocompleteFilterEnabled
                && !nextProps.configuration.isConnected
                && !nextProps.destinationsFilterEnabled;
            this.setState({ shouldRenderAutocomplete });
        }
    }

    render() {
        const {
            settings, search, configuration, searchResults, isLoading, error, onChangeRoomsQuantity, onRemoveRoom,
            onChangeAdults, container, onChangeChildren, onChangeChildrenAge, onChangeDates, onChangeLanguage,
            onChangeCurrency, onChangePromoCode, regionOptions, id, channelId, promoCodePlaceholder,
            onDestinationSelected, destinationSelected, onSearchBarClick, getUrlParams, filters,
            onPropertiesRendered, destinationsLoading, destinationsFilterEnabled,
            searchInputPlaceHolder, autocompleteFilterApplied, dispatchApplyCoupon, coupon, promoCode,
            isDatePickerWrapperEnabled, maxDate,
        } = this.props;

        const {
            fullWidth, searchButtonEnabled,
            showLanguageSelector, showCurrencySelector,
        } = configuration;
        const { propertyCode, promotionalCodeEnabled, couponIntegration, couponVoucherTerm, isMultiProperty } = settings;

        const { shouldRenderAutocomplete } = this.state;

        const handleDatesChange = ({ startDate, endDate }) => {
            const dates = { startDate, endDate };
            onChangeDates(id, dates);
        };

        let isConnected;
        let hideOccupancySelector;
        let hideDatePickerSelector;
        if (configuration) {
            hideOccupancySelector = configuration.hideOccupancySelector || false;
            hideDatePickerSelector = configuration.hideDatePickerSelector || false;
            isConnected = inHotelProfilePage() || configuration.isConnected;
        }
        const onSearchResults = () => {
            if (onSearchBarClick && destinationSelected) {
                let finalDestination;
                const params = getUrlParams(id, true);
                if (destinationSelected.type === 'hotel') {
                    finalDestination = destinationSelected.value;
                }
                if (destinationSelected.type === 'city') {
                    finalDestination = `${destinationSelected.countryEnglishName}/${destinationSelected.englishValue}`;
                }
                if (destinationSelected.type === 'country') {
                    finalDestination = destinationSelected.englishValue;
                }
                onSearchBarClick(finalDestination, destinationSelected.type, params);
            } else {
                const params = getUrlParams(id, false);
                // eslint-disable-next-line max-len
                searchResults(id, isConnected, configuration, destinationSelected, params, settings.isMultiProperty, settings.hotelsFilters);
            }
        };
        const changeCurrency = currency => onChangeCurrency(id, currency, isMultiProperty);
        const changeLanguage = lang => onChangeLanguage(id, lang, isMultiProperty, channelId, propertyCode);

        const newFilterDataAndLabels = { ...filterDataAndLabels, searchInputPlaceHolder };

        const {
            resetAutocompleteFilters,
            setAutocompleteFilter,
            onFilterProperties,
            onChangeSearchInput,
            handleOnGetPlace,
        } = this.context;

        const nameFilterProps = {
            onChange                      : onChangeSearchInput,
            filter                        : filters?.propertyName,
            filterDataAndLabels           : newFilterDataAndLabels,
            searchInputCategoriesLabels   : filterDataAndLabels.searchInputCategoriesLabels,
            searchInputIntlNotFindMessage : filterDataAndLabels.searchInputIntlNotFindMessage,
            searchInputPlaceHolder        : newFilterDataAndLabels.searchInputPlaceHolder,
            isLoading,
            resetAutocompleteFilters,
            setAutocompleteFilter,
            onFilterProperties,
            autocompleteFilterApplied,
        };

        if (!isLoading && error) {
            return (
                <ErrorMessage>
                    <FormattedMessage id="bf.errorOnLoadingData" defaultMessage="bf.errorOnLoadingData" />
                </ErrorMessage>
            );
        }

        const couponCodeEnabled = couponIntegration !== COUPON_INTEGRATION.NONE;
        const hasSpecialCode = promotionalCodeEnabled || couponCodeEnabled;
        const currentOccupancy = getOccupancyForHotelsearch(0, search.occupancy);
        const globalMinOccupancy = isMultiProperty
            ? 0
            : settings.minOccupancy;
        const isEECProperty = settings?.widgetType === ECHO_WIDGET;
        const calendarPriceMode = (isMultiProperty || isEECProperty || !settings?.calendarPrices)
            ? 'NONE'
            : settings?.calendarPrices;

        const calendarLanguage = getRegionalLocale(search.language, settings.preferredLocales);
        const wrapperEnabledCalendar = () => <DataFetchingDateRangeSelector
            showInputs
            currentLanguage={calendarLanguage}
            checkIn={search.checkIn ? moment(search.checkIn, 'YYYY-MM-DD').startOf('day') : null}
            checkOut={search.checkOut ? moment(search.checkOut, 'YYYY-MM-DD').startOf('day') : null}
            maxDate={maxDate}
            onChange={handleDatesChange}
            occupancy={currentOccupancy}
            calendarPricesMode={calendarPriceMode}
            propertyCode={propertyCode}
            globalMinOccupancy={globalMinOccupancy}
            minLengthOfStay={settings.minLengthOfStay}
            maxLengthOfStay={settings.maxLengthOfStay}
            minNightOffset={settings.minNightOffset}
            notAvailableDates={settings.blackoutPeriods}
            channelId={isMultiProperty ? null : channelId}
            isMultiProperty={isMultiProperty}
            currencyDisplay={settings.currencyDisplay}
            currencyCode={search?.currency?.code}
            currencySymbol={search?.currency?.symbol}
        />;

        const wrapperDisabledCalendar = () => <DateRangeSelector
            id={id}
            checkIn={search.checkIn}
            checkOut={search.checkOut}
            minLengthOfStay={settings.minLengthOfStay}
            maxLengthOfStay={settings.maxLengthOfStay}
            minNightOffset={settings.minNightOffset}
            onChangeDates={onChangeDates}
            notAvailableDates={settings.blackoutPeriods}
        />;

        const useNewCalendar = getUrlParams('date-picker-wrapper-enabled', false) || isDatePickerWrapperEnabled;
        const datePickerWrapper = () => useNewCalendar
            ? wrapperEnabledCalendar()
            : wrapperDisabledCalendar();

        return (
            <SearchBar.Wrapper isLoading={isLoading} fullWidth={fullWidth}>
                {shouldRenderAutocomplete ? (
                    <SearchBarItem
                        className="kbe-header-filter-by-name-wrapper"
                        label={<FormattedMessage id="bf.searchV2" defaultMessage="bf.searchV2" />}
                    >
                        <PropertiesFilterByName
                            {...nameFilterProps}
                            language={search.language}
                            filterOnClick={false}
                            onGetPlace={handleOnGetPlace}
                        />
                    </SearchBarItem>
                ) : null}
                {destinationsFilterEnabled && !destinationsLoading ? <SelectWithSearchContainer
                    id={id}
                    regionOptions={regionOptions}
                    channelId={channelId}
                    select={onDestinationSelected}
                    language={search.language}
                    className="kbe-destinations-filter-wrapper"
                    title={<FormattedMessage id="bf.destination" defaultMessage="bf.destination" />}
                /> : null}
                {!hideDatePickerSelector && datePickerWrapper()}
                {!hideOccupancySelector && (
                    <OccupancySelector
                        occupancy={search.occupancy}
                        childrenEnabled={settings.childrenEnabled}
                        minOccupancy={settings.minOccupancy}
                        maxOccupancy={settings.maxOccupancy}
                        maxChildAge={settings.maxChildAge}
                        minChildAge={settings.minChildAge}
                        maxRoomsPerBooking={settings.maxRoomsPerBooking}
                        onChangeRoomsQuantity={onChangeRoomsQuantity}
                        onRemoveRoom={onRemoveRoom}
                        onChangeAdults={onChangeAdults}
                        onChangeChildren={onChangeChildren}
                        onChangeChildrenAge={onChangeChildrenAge}
                        container={container}
                    />
                )}
                {hasSpecialCode ? <SpecialCodes
                    hasPromoCode={promotionalCodeEnabled}
                    hasCouponCode={couponCodeEnabled}
                    couponVoucherTerm={couponVoucherTerm}
                    coupon={coupon}
                    promoCodePlaceholder={promoCodePlaceholder}
                    onChangePromoCode={onChangePromoCode}
                    applyCoupon={dispatchApplyCoupon}
                    channelId={channelId}
                    promotion={promoCode}
                /> : null}
                <div className="kbe-search-bar-action-button-wrapper">
                    <SearchBar.Button
                        onClick={onSearchResults}
                        isConnected={isConnected}
                        isEnabled={searchButtonEnabled}
                        onPropertiesRendered={onPropertiesRendered}
                    />
                    {(showCurrencySelector || showLanguageSelector) ? <UserPreferences
                        defaultLanguage={settings.language}
                        currentLanguage={search.language}
                        availableLanguages={settings.availableLanguages}
                        defaultCurrency={settings.defaultCurrency}
                        currentCurrency={search.currency}
                        availableCurrencies={settings.availableCurrencies}
                        onChangeLanguage={changeLanguage}
                        onChangeCurrency={changeCurrency}
                        showLanguageSelector={showLanguageSelector}
                        showCurrencySelector={showCurrencySelector}
                        currencyDisplay={settings.currencyDisplay}
                    /> : null}
                </div>
            </SearchBar.Wrapper>
        );
    }
}
SearchBar.Wrapper = Wrapper;
SearchBar.Button = SearchBarButton;
SearchBar.contextType = HotelsContext;

SearchBar.defaultProps = {
    regionOptions             : {},
    channelId                 : '',
    onWidgetLoaded            : () => {},
    onPropertiesRendered      : () => {},
    onSearchBarClick          : undefined,
    onDestinationSelected     : () => {},
    destinationSelected       : undefined,
    destinationsFilterEnabled : false,
    promoCodePlaceholder      : '',
    isDatePickerWrapperEnabled: false,
    maxDate                   : moment().add(1, 'year').startOf('day').toDate(),
    isMultiProperty           : false,
};

SearchBar.propTypes = {
    id                        : PropTypes.string.isRequired,
    configuration             : PropTypes.shape(searchBarShape).isRequired,
    destinationSelected       : PropTypes.shape(),
    container                 : PropTypes.oneOfType([ PropTypes.instanceOf(Element), PropTypes.object ]).isRequired,
    error                     : PropTypes.bool.isRequired,
    isLoading                 : PropTypes.bool.isRequired,
    destinationsLoading       : PropTypes.bool.isRequired,
    settings                  : PropTypes.shape(settingsShape).isRequired,
    search                    : PropTypes.shape(searchShape).isRequired,
    searchResults             : PropTypes.func.isRequired,
    onChangeDates             : PropTypes.func.isRequired,
    onChangeRoomsQuantity     : PropTypes.func.isRequired,
    onRemoveRoom              : PropTypes.func.isRequired,
    onChangeAdults            : PropTypes.func.isRequired,
    onChangeChildren          : PropTypes.func.isRequired,
    onChangeChildrenAge       : PropTypes.func.isRequired,
    onChangeLanguage          : PropTypes.func.isRequired,
    onChangeCurrency          : PropTypes.func.isRequired,
    onChangePromoCode         : PropTypes.func.isRequired,
    channelId                 : PropTypes.string,
    regionOptions             : PropTypes.shape(),
    onWidgetLoaded            : PropTypes.func,
    onPropertiesRendered      : PropTypes.func,
    onDestinationSelected     : PropTypes.func,
    onSearchBarClick          : PropTypes.func,
    getUrlParams              : PropTypes.func.isRequired,
    destinationsFilterEnabled : PropTypes.bool,
    promoCodePlaceholder      : PropTypes.string,
    isDatePickerWrapperEnabled: PropTypes.bool,
    maxDate                   : PropTypes.oneOfType([ PropTypes.instanceOf(Date), PropTypes.string ]),
    isMultiProperty           : PropTypes.bool,
};

export default SearchBar;
